import { apiClient } from './ApiClient';

export interface DataManagementParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  status?: string;
  propertyType?: string;
  transactionType?: string;
  category?: string;
  startDate?: string;
  endDate?: string;
  minAmount?: number;
  maxAmount?: number;
  period?: string;
}

export interface PaginationInfo {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface DataManagementResponse<T> {
  data: T[];
  pagination: PaginationInfo;
}

export const DataManagementService = {
  // Get assets table data
  getAssetsTable: async (
    params: DataManagementParams = {},
  ): Promise<DataManagementResponse<any>> => {
    try {
      const response = await apiClient.get('/data-management/assets', {
        params,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching assets table:', error);
      throw error;
    }
  },

  // Get transactions table data
  getTransactionsTable: async (
    params: DataManagementParams = {},
  ): Promise<DataManagementResponse<any>> => {
    try {
      const response = await apiClient.get('/data-management/transactions', {
        params,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching transactions table:', error);
      throw error;
    }
  },

  // Get financial summary table data
  getFinancialSummaryTable: async (
    params: DataManagementParams = {},
  ): Promise<DataManagementResponse<any>> => {
    try {
      const response = await apiClient.get(
        '/data-management/financial-summary',
        { params },
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching financial summary table:', error);
      throw error;
    }
  },

  // Update asset data
  updateAssetData: async (id: string, data: any): Promise<any> => {
    try {
      const response = await apiClient.put(
        `/data-management/assets/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error('Error updating asset data:', error);
      throw error;
    }
  },

  // Update transaction data
  updateTransactionData: async (id: string, data: any): Promise<any> => {
    try {
      const response = await apiClient.put(
        `/data-management/transactions/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error('Error updating transaction data:', error);
      throw error;
    }
  },
};

export default DataManagementService;
